import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8.333 12.5V10m3.334 2.5V10M2.5 5.833h15v0c-.777 0-1.165 0-1.471.127-.409.17-.733.494-.902.902C15 7.17 15 7.557 15 8.334v5c0 1.57 0 2.357-.488 2.845s-1.274.488-2.845.488H8.333c-1.571 0-2.357 0-2.845-.488S5 14.905 5 13.334v-5c0-.777 0-1.165-.127-1.472a1.67 1.67 0 0 0-.902-.902c-.306-.127-.694-.127-1.471-.127zm5.89-3.024c.095-.089.304-.167.595-.223A5.6 5.6 0 0 1 10 2.5c.367 0 .723.03 1.015.086.29.056.5.134.595.223"
    />
  </svg>
);
export default SvgDelete;
